/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-10 21:03:24
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-11 14:02:05
 */
import http from "@/axios/index";

/**
 * 获取列表数据分页
 * @param postObj
 */
export function getListByPages(params) {
  const url = '/loss/getListByPage';
  return http.post(url, params);
}

/**
 * @brief: 下载模版
 * @author: Scarlett Xiao
 * @Date: 2020-11-13 09:58:31
 * 旧版: fileDownload/downloadLossTemplate
 */
export function downloadTemplate() {
  return '/fileDownload/downloadFile/downloadLossTemplate';
}
/**
 * @brief: 导出
 * @author: Scarlett Xiao
 * @Date: 2020-11-13 10:01:16
 */
export function exportTable() {
  return '/loss/conditionExportTable';
}
/**
 * @brief: 导入
 * @author: Scarlett Xiao
 * @Date: 2020-11-13 10:40:43
 */
export function importTable() {
  return '/loss/importLossTable';
}
/**
 * @Author: hsg
 * @Date: 2021-05-24 15:59:23
 * @Descripttion: 根据角色权限获取养殖场下拉列表
 * @param {*}
 */
export function getBaseListsByUser() {
  const url = '/baseData/queryBaseDataListByRole';
  return http.get(url);
}
/**
 * @Author: hsg
 * @Date: 2021-05-31 16:09:03
 * @Descripttion: 获取基地下的除总仓下的基地
 * @param {string} baseId
 */
export function queryBaseGroupList(baseId) {
  const url = '/baseGroup/queryBaseGroupList';
  return http.post(url, {
    baseId: baseId,
    groupFlag: 0,
  });
}
/**
 * @Author: hsg
 * @Date: 2021-03-26 14:25:45
 * @Descripttion: 获取区域塘口接口
 * @param {string} groupId 区域id
 */
export function listDataPermissionBoxData(groupId) {
  const url = '/boxData/listDataPermissionBoxData/' + groupId;
  return http.get(url);
}
/**
 * 根据机构id获取生产造次列表
 * @param orgId 机构id
 */
export function getBatchList(orgId) {
  const url = '/periodData/getByBaseIdPeriod/' + orgId;
  return http.get(url);
}
/**
 * 根据机构id获取一级机构信息
 * @param orgId 机构id
 */
export function getOrgInfoByOrgId(orgId) {
  const url = '/org/getParentOrg/' + orgId;
  return http.get(url);
}
/**
 * 获取养殖品种下拉列表
 * @param orgId 机构id
 */
export function getBreedList(orgId) {
  const url = '/breedData/getListMap/orgId/' + orgId;
  return http.get(url);
}
/**
 * @Author: lishiqiao
 * @Date: 2021-08-19 09:35:08
 * @description: 获取养殖品类下拉列表
 * @param {*} baseId 基地id
 */
export function getBreedTypeList(baseId) {
  const url = '/breedData/getBreedType/' + baseId;
  return http.get(url);
}
/**
 * 根据类型查询字典
 * @param type 类型
 */
export function getDictionaryByType(type) {
  const url = '/dictionary/getListMap/type/' + type;
  return http.get(url);
}